import { useTheme } from '../../styles/ThemeContext';

/**
 * Custom warning modal for DG (Dangerous Goods) conflicts
 */
export function DGWarningModal({ isOpen, onClose, onConfirm, details }) {
  const { theme } = useTheme();
  const c = theme.colors;

  if (!isOpen) return null;

  const { existingDG, existingNonDG, newDG, newNonDG } = details;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: c.overlay, display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }} onClick={onClose}>
      <div style={{ background: c.bg, border: '2px solid ' + c.errorBorder, borderRadius: 6, maxWidth: 500, width: '90%', boxShadow: '0 16px 32px ' + c.shadow }} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div style={{ background: c.errorBg, borderBottom: '1px solid ' + c.errorBorder, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12 }}>
          <span style={{ fontSize: 24 }}>⚠️</span>
          <div>
            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: c.error }}>Dangerous Goods Warning</h3>
            <p style={{ margin: '4px 0 0 0', fontSize: 11, color: c.textSecondary }}>Mixing DG and non-DG products</p>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '20px 20px 16px' }}>
          <p style={{ margin: '0 0 16px 0', fontSize: 13, lineHeight: 1.6, color: c.text }}>
            You are attempting to mix Dangerous Goods (DG) and non-DG products in the same shipping unit:
          </p>
          <div style={{ background: c.bgCard, border: '1px solid ' + c.border, borderRadius: 4, padding: 12, marginBottom: 16 }}>
            <table style={{ width: '100%', fontSize: 12 }}>
              <tbody>
                {existingDG > 0 && <tr><td style={{ padding: '4px 8px', color: c.textSecondary }}>Existing DG products:</td><td style={{ padding: '4px 8px', fontFamily: 'monospace', fontWeight: 600 }}><span style={{ color: c.error }}>{existingDG}</span></td></tr>}
                {existingNonDG > 0 && <tr><td style={{ padding: '4px 8px', color: c.textSecondary }}>Existing non-DG products:</td><td style={{ padding: '4px 8px', fontFamily: 'monospace', fontWeight: 600 }}>{existingNonDG}</td></tr>}
                {newDG > 0 && <tr><td style={{ padding: '4px 8px', color: c.textSecondary }}>Adding DG products:</td><td style={{ padding: '4px 8px', fontFamily: 'monospace', fontWeight: 600 }}><span style={{ color: c.error }}>+{newDG}</span></td></tr>}
                {newNonDG > 0 && <tr><td style={{ padding: '4px 8px', color: c.textSecondary }}>Adding non-DG products:</td><td style={{ padding: '4px 8px', fontFamily: 'monospace', fontWeight: 600 }}>+{newNonDG}</td></tr>}
              </tbody>
            </table>
          </div>
          <div style={{ background: c.errorBg, border: '1px solid ' + c.errorBorder, borderRadius: 4, padding: '10px 12px', marginBottom: 20 }}>
            <p style={{ margin: 0, fontSize: 12, lineHeight: 1.5, color: c.error }}><strong>⚠️ Warning:</strong> Mixing DG and non-DG products in the same unit may violate shipping regulations and safety requirements.</p>
          </div>
          <p style={{ margin: 0, fontSize: 12, color: c.textSecondary }}>Do you want to proceed anyway?</p>
        </div>

        {/* Footer */}
        <div style={{ borderTop: '1px solid ' + c.border, padding: '12px 20px', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <button onClick={onClose} style={theme.btnG}>Cancel</button>
          <button onClick={onConfirm} style={{ ...theme.btnDanger, fontWeight: 600 }}>Proceed Anyway</button>
        </div>
      </div>
    </div>
  );
}
